import { useEffect, useRef } from "react";

export default function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  const mouse = useRef({ x: 0, y: 0 });
  const ring = useRef({ x: 0, y: 0 });

  let idleTimeout;

  useEffect(() => {
    const onMouseMove = (e) => {
      if (!dotRef.current || !ringRef.current) return;

      mouse.current.x = e.clientX;
      mouse.current.y = e.clientY;

      // ----------------------------
      // Detect interactive elements to skip cursor animation
      // ----------------------------
      const skipCursor = e.target.closest("a, button, input, textarea, select, [role='button'], #links");

      if (skipCursor) {
        dotRef.current.style.opacity = "0";
        ringRef.current.style.opacity = "0";

        document.body.style.cursor = "pointer"; // show browser pointer
        return; // stop animation
      } else {
        dotRef.current.style.opacity = "1";
        ringRef.current.style.opacity = "1";

        document.body.style.cursor = "none"; // hide system pointer
      }

      // Dot follows instantly
      dotRef.current.style.transform =
        `translate(-50%, -50%) translate(${e.clientX}px, ${e.clientY}px)`;

      // Ring position (lag)
      ringRef.current.style.transform =
        `translate(-50%, -50%) translate(${ring.current.x}px, ${ring.current.y}px)`;

      // Turn white on images
      if (e.target.tagName === "IMG") {
        dotRef.current.style.background = "#fff";
        ringRef.current.style.borderColor = "#fff";
      } else {
        dotRef.current.style.background = "#5bc8ff";
        ringRef.current.style.borderColor = "#bfeaff";
      }

      // Ring moving state
      ringRef.current.classList.add("is-moving");
      clearTimeout(idleTimeout);
      idleTimeout = setTimeout(() => {
        if (ringRef.current) ringRef.current.classList.remove("is-moving");
      }, 120);
    };

    window.addEventListener("mousemove", onMouseMove);

    const animate = () => {
      ring.current.x += (mouse.current.x - ring.current.x) * 0.12;
      ring.current.y += (mouse.current.y - ring.current.y) * 0.12;

      if (ringRef.current) {
        ringRef.current.style.transform =
          `translate(-50%, -50%) translate(${ring.current.x}px, ${ring.current.y}px)`;
      }

      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener("mousemove", onMouseMove);
      clearTimeout(idleTimeout);
      document.body.style.cursor = "auto"; // restore on unmount
    };
  }, []);

  return (
    <>
      <div ref={dotRef} className="cursor-dot" />
      <div ref={ringRef} className="cursor-ring" />
    </>
  );
}
